module.exports = __webpack_public_path__ + "img/tip.1534bbc5.png";